import Cookie from 'js-cookie';
import moment from 'moment';
import { HIDE_CRISIS_ALERT, LANGUAGE_SET } from '../actions/UI';
import {
  COOKIE_LANGUAGE_PREFERENCE,
  COOKIE_HIDDEN_CRISIS_ALERTS,
  MULTILINGUAL,
} from '../../config/constants'

const uiMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  switch (action.type) {
    case LANGUAGE_SET: {
      if (!MULTILINGUAL) {
        break;
      }

      const currentLanguage = getState().getIn(['ui', 'language']);

      const newLanguage = action.language;

      const languageSwitched = currentLanguage !== newLanguage;

      if (!languageSwitched) {
        break;
      }

      moment.locale(newLanguage);

      const agreedCookieCategories = Cookie.get('cookie-agreed-categories');

      const isPreferencesCookieAgreed = agreedCookieCategories?.includes('preferences');

      if (!isPreferencesCookieAgreed) {
        break;
      }

      Cookie.set(COOKIE_LANGUAGE_PREFERENCE, newLanguage);

      break;
    }

    case HIDE_CRISIS_ALERT: {
      const hiddenAlerts = Cookie.get(COOKIE_HIDDEN_CRISIS_ALERTS);
      const updatedHiddenAlerts = hiddenAlerts ? JSON.parse(hiddenAlerts) : [];

      updatedHiddenAlerts.push(action.nid);

      Cookie.set(COOKIE_HIDDEN_CRISIS_ALERTS, JSON.stringify(updatedHiddenAlerts));

      break;
    }

    default:
      break;
  }

  return next(action);
};

export default uiMiddleware;
